import { get, last, orderBy, isEmpty } from 'lodash';
import { TYPE_INSTAGRAM_STORY } from '../../../constants/networks';

export default {
    data() {
        return {
            taskContent: null,
            isTaskContentLoading: false
        };
    },
    computed: {
        taskParamId() {
            return this.$route.params.task_id;
        },
        deliverableParamId() {
            return this.$route.params.deliverable_id;
        },
        contentParamId() {
            return this.$route.params.content_id;
        },
        task() {
            return get(this.brief, 'tasks', []).find((task) => task.id === parseInt(this.taskParamId));
        },
        isInstagramStoryTask() {
            return get(this.task, 'type') === TYPE_INSTAGRAM_STORY;
        },
        deliverables() {
            const deliverables = get(this.brief, 'deliverables', []).filter((deliverable) => {
                return (
                    deliverable.member_id === get(this.brief, 'member_id') &&
                    deliverable.task_id === get(this.task, 'id')
                );
            });
            if (isEmpty(deliverables)) {
                return [];
            }

            return orderBy(deliverables, 'id', 'asc');
        },
        deliverable() {
            if (this.deliverableParamId) {
                return this.deliverables.find((myDeliverable) => myDeliverable.id === this.deliverableParamId);
            }

            if (this.isTaskEvergreen) {
                return last(this.deliverables);
            }

            let deliverable = this.deliverables.find((myDeliverable) => !myDeliverable.is_complete);

            if (this.isInstagramStoryTask) {
                deliverable = this.deliverables
                    .filter((myDeliverable) => {
                        return myDeliverable.content.some((content) => {
                            return !content.insights_stored_at;
                        });
                    })
                    .find((myDeliverable) => myDeliverable.is_complete);
            }

            return deliverable ? deliverable : last(this.deliverables);
        },
        isTaskComplete() {
            return get(this.task, 'status') === 'complete';
        },
        isTaskEvergreen() {
            return get(this.task, 'quantity') === 0;
        },
        isDeliverableComplete() {
            return !!get(this.deliverable, 'is_complete');
        },
        deliverableHasInsights() {
            return !!get(this.deliverable, 'content[0].insights_stored_at');
        },
        taskRequiresApproval() {
            return !!get(this.task, 'requires_approval');
        },
        taskContentUrl() {
            return `/api/v1/activation-briefs/${this.briefParamId}/tasks/${this.taskParamId}/content?expand[]=media_library_content`;
        }
    },
    methods: {
        loadActivationTaskContent() {
            this.isTaskContentLoading = true;

            return this.$http
                .get(this.taskContentUrl)
                .then((res) => {
                    this.taskContent = res.data;
                    this.isTaskContentLoading = false;
                    return res;
                })
                .catch(this.handleHttpError);
        }
    }
};
